export const getSessionStorageItem = <T>(key: string, defaultValue: T): T => {
  try {
    const item = sessionStorage.getItem(key)
    return item ? JSON.parse(item) : defaultValue
  } catch (error) {
    console.error(`Error reading ${key} from sessionStorage:`, error)
    return defaultValue
  }
}

export const setSessionStorageItem = <T>(key: string, value: T): void => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    console.error(`Error writing ${key} to sessionStorage:`, error)
  }
}

export const removeSessionStorageItem = (key: string): void => {
  try {
    sessionStorage.removeItem(key)
  } catch (error) {
    console.error(`Error removing ${key} from sessionStorage:`, error)
  }
}

export const clearAllBrowserSessionStorage = (): void => {
  try {
    sessionStorage.clear()
  } catch (error) {
    console.error('Error clearing sessionStorage:', error)
  }

  try {
    sessionStorage.clear()
  } catch (error) {
    console.error('Error clearing sessionStorage:', error)
  }
}
